export const POINT_TYPE_BLOCK   = 0;
export const POINT_TYPE_RESERVE = 1;
export const POINT_TYPE_FREE    = 2;
export const POINT_TYPE_EMPTY   = 3;


/** WEBPACK FOOTER **
 ** ./src/point-types.js
 **/